module.exports = __webpack_public_path__ + "img/banner-txt.666ffb1d.png";